import styled from 'styled-components';

export const Signature = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;

	@media only screen and (min-width: 601px) {
		background-color: #F5F5F5;
	}

	@media only screen and (max-width: 600px) {
		padding: 16px;
		background-color: white;
	}
`;

Signature.Container = styled.div`
	@media only screen and (min-width: 601px) {
		max-width: 600px;
		background-color: white;
		margin: 2rem auto;
		padding: 32px;
	}
`;

Signature.Actions = styled.div`
	display: flex;
`;

Signature.Title = styled.span`
	font-weight: 500;
	font-size: 24px;
	line-height: 29px;
	color: #26282A;
`;

Signature.SignaturePad = styled.div`
	margin-top: 24px;
`;

Signature.SignaturePad.ButtonGroup = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	width: 100%;
`;

Signature.SignaturePad.InputContainer = styled.div`
	width: 100%;
	height: 214px;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	border-top-left-radius: 0 !important;
	position: relative;
	margin-bottom: 6.33px;

	@media only screen and (max-width: 600px) {
		width: 100%;
	}
`;

Signature.SignaturePad.TextArea = styled.textarea`
	width: ${({ width }) => `${width}px`};
	height: 211px;
	line-height: normal !important;
	color: #000 !important;
	border: none;
	border-radius: 8px;
	text-align: center;
	font-family: Ephesis !important;
	font-size: 35px !important;
	font-style: normal;
	font-weight: 550;
	resize: none !important;
	padding: 8px !important;
`;

Signature.Button = styled.button`
	background-color: #5B7FFF;
	color: #FFF;

	width: 100%;
	height: 48px;
	border-radius: 8px;
	border: none;
	cursor: pointer;
	transition: background-color 0.2s, opacity 0.2s;

	&& {
		font-size: 16px !important;
		font-weight: 600 !important;
	}

	&:hover:not(:disabled) {
		background-color: #4A6FEE;
	}

	&:disabled {
		background-color: #D9E1E8;
		color: #9CA3AB;
		cursor: not-allowed;
	}
`;
